<template>
  <v-card>
    <v-card-title>
      <span class="text-h6">Edit Item Checkout</span>
    </v-card-title>

    <v-divider></v-divider>

    <validation-observer ref="observer" v-slot="{ invalid }">
      <form @submit.prevent="submit">
        <v-container>
          <v-row class="pa-4">
            <!-- Kode Barang -->
            <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="Kode Barang"
                rules="required"
              >
                <v-text-field
                  disabled
                  v-model="data.sku"
                  label="Kode Barang"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="Kode Barang"
                rules="required"
              >
                <v-text-field
                  v-model="data.product_name"
                  label="Nama Produk"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <v-text-field
                disabled
                v-model="data.rfid"
                label="RFID"
              ></v-text-field>
            </v-col>
            <!-- Berat -->
            <v-col cols="6">
              <validation-provider
                v-slot="{ errors }"
                name="Berat"
                rules="required"
              >
                <v-text-field
                  v-model="data.weight"
                  label="Berat"
                  type="number"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <!-- Jenis -->
            <v-col cols="6">
              <v-text-field v-model="data.type" label="Jenis"></v-text-field>
            </v-col>
            <!-- Kadar -->
            <v-col cols="6">
              <v-text-field
                v-model="data.purity"
                label="Kadar"
                type="number"
              ></v-text-field>
            </v-col>
            <!-- Kualitas -->
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="data.quality"
                label="Kualitas"
              ></v-text-field>
            </v-col>
            <!-- Cabang -->
            <v-col cols="12" sm="6">
              <v-select
                v-model="data.branch_id"
                label="Cabang"
                :items="selectCabang"
                item-text="branch_name"
                item-value="id"
                @input="getSubCabang"
                disabled
              >
              </v-select>
            </v-col>
            <!-- Sub Cabang -->
            <v-col cols="12" sm="6">
              <v-select
                v-model="data.sub_branch_id"
                label="Sub Cabang"
                :items="selectSubCabang"
                item-text="sub_branch_name"
                item-value="id"
                disabled
              >
              </v-select>
            </v-col>
            <!-- Kondisi -->
            <v-col cols="12" sm="6">
              <v-select
                v-model="data.conditions"
                label="Kondisi"
                :items="selectKondisi"
                item-text="label"
                item-value="value"
              >
              </v-select>
            </v-col>
            <!-- Status -->
            <v-col cols="12" sm="6">
              <v-select
                v-model="data.status"
                label="Status"
                :items="selectStatus"
                item-text="label"
                item-value="value"
              >
              </v-select>
            </v-col>
            <!-- Catatan -->
            <v-col cols="12">
              <v-text-field v-model="data.note" label="Catatan"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" v-if="data.status === 'Terjual'">
              <v-text-field
                v-model="data.total_price"
                :rules="[numberRule]"
                prefix="Rp."
                label="Total Harga"
                :disabled="!data.branch_id"
                >showedData
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" v-if="data.status === 'Terjual'">
              <v-text-field
                v-model="data.customer_name"
                label="Nama Pelanggan"
                :disabled="!data.branch_id"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" v-if="data.status === 'Terjual'">
              <validation-provider
              v-slot="{ errors }"
              name="Date"
              rules="required"
              >
              <v-datetime-picker 
              v-model="data.date_order"
              :error-messages="errors"
              label="Tanggal Checkout"
              timeFormat=HH:mm:ss
              ></v-datetime-picker>
              </validation-provider>
             </v-col>

            <v-col cols="12">
              <v-row v-if="data.status === 'Terjual'" class="px-4">
                <v-col cols="6">
                  <!-- <validation-provider
                    v-slot="{ errors }"
                    name="Date"
                    rules="required"
                  > -->
                    <!-- <v-time-picker
                      v-model="data.time"
                      ampm-in-title
                      full-width
                      :error-messages="errors"
                    ></v-time-picker> -->
                  <!-- </validation-provider> -->
                </v-col>
                <!-- <v-col cols="6">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Date"
                    rules="required"
                  >
                    <v-date-picker
                      v-model="data.date"
                      full-width
                      :error-messages="errors"
                    ></v-date-picker>
                  </validation-provider>
                </v-col> -->
              </v-row>
            </v-col>
            <v-col cols="12" v-if="selectedFile === ''">
              Ganti Foto
              <v-img
                :src="data.photo_product"
                :alt="data.photo_product"
              ></v-img>
            </v-col>
            <!-- Buton Unggah Foto -->
            <!-- <v-col cols="12">
              <v-card
                class="mt-2 pa-6"
                max-width="600"
                v-if="selectedFile"
                elevation="0"
              >
                <div class="pt-2 py-4 text-center">
                  <img :src="fileImage" width="250" />
                </div>
              </v-card>

              <v-card class="mt-2 pa-6" elevation="0">
                <v-btn
                  block
                  color="myPrimary"
                  outlined
                  depressed
                  :loading="isSelecting"
                  @click="onButtonClick"
                >
                  Unggah Foto
                </v-btn>
                <input
                  ref="uploader"
                  class="d-none"
                  type="file"
                  accept="image/*"
                  @change="onFileChanged"
                />picker
              </v-card>
            </v-col> -->
          </v-row>
        </v-container>
      </form>

      <v-spacer></v-spacer>
      <v-card-actions class="d-flex justify-end px-4">
        <v-btn color="myPrimary white--text" outlined @click="closeEdit">
          Cancel
        </v-btn>
        <v-btn
          color="myPrimary white--text"
          @click="saveEdit"
          picker
          :disabled="invalid"
        >
          Save
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

import dataService from "../../services/data.service";
import Vue from 'vue'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker)

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty",
});

export default {
  props: ["data", "PRINT"],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      selectedFile: [],
      fileImage: "",
      isSelecting: false,
      errors: [],

      selectCabang: [],
      selectSubCabang: [],
      selectKondisi: [
        { value: "Baru", label: "Baru" },
        { value: "Bekas", label: "Bekas" },
      ],
      selectStatus: [
        { value: "Tersedia", label: "Tersedia" },
        { value: "Belum Terpindai", label: "Belum Terpindai" },
        { value: "Terjual", label: "Terjual" },
        { value: "Perbaikan", label: "Perbaikan" },
        { value: "Hilang", label: "Hilang" },
      ],
    };
  },

  created() {
    this.getCabang();
    this.getSubCabang();
  },

  methods: {
    numberRule(v) {
      if (v != undefined) {
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return "Number must greater than zero (0)";
      } else {
        return true;
      }
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      this.fileImage = URL.createObjectURL(this.selectedFile);

      if (e.target.files.length === 0) {
        this.fileImage = URL.createObjectURL(null);
      }
    },
    // Get Cabang
    async getCabang() {
      await dataService.getCabang().then((res) => {
        this.selectCabang = res.data;
      });
    },

    // Get Sub Cabang
    async getSubCabang() {
      await dataService.getAllSubCabang().then((res) => {
        const data = res.data.data;
        const value = data.filter((dt) => dt.branch_id == this.data.branch_id);

        this.selectSubCabang = [
          { sub_branch_name: "None", id: null },
          ...value,
        ];
      });
    },

    closeEdit() {
      this.$emit("closeEdit");
    },
    saveEdit() {
      // console.log(data);
      this.$emit("saveEdit", this.data);
    },
  },
};
</script>
